<template>
    <main class="pd-main">
        <div class="main-content">
            <circle-spin class="m-0" v-if="firstLoad"></circle-spin>
            <div class="row" v-else >       
                <div class="col-xl-6">
                    <div class="card">
                        <h5 class="card-title"><strong>LISTENERS </strong></h5>
                        <div class="card-body">
                            <v-client-table :columns="columns" :data="data1" :options="options">
                                <div slot="id" slot-scope="props" >{{props.index}}</div>
                                <div slot="nickname" slot-scope="props" >@{{props.row.nickname}}</div>                          
                            </v-client-table>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                <div class="card">
                    <h5 class="card-title"><strong>HELP SEEKERS </strong></h5>
                    <div class="card-body">
                        <v-client-table :columns="columns" :data="data2" :options="options"> 
                            <div slot="id" slot-scope="props" >{{props.index}}</div>                          
                            <div slot="nickname" slot-scope="props" >@{{props.row.nickname}}</div>                          
                        </v-client-table>
                        
                    </div>
                </div>
                </div>
            </div>   
        </div>
    </main>
</template>

<script>
import Vue from 'vue';
import axios from 'axios'

export default {
    data() {
        return {
            firstLoad: true,
            columns: ['id', 'nickname','email'],
            data1: [],
            data2: [],
            options: { 
                headings: {
                    id: 'S/N',
                    nickname: 'Nickname',
                    email: 'Email'
                },
                sortable: ['nickname'],
                filterable: ['nickname']
            }
        }
    },
    mounted() {
        axios.get('/users/?condition=listener')
        .then(res => {
                if(!res.data.results) return
                else{
                    this.data1 = res.data.results

                }
            axios.get('/users/?condition=helpseeker')
            .then(res => {
                this.firstLoad = false
                if(!res.data.results) return
                else{
                     this.data2 = res.data.results
                }
            })
            .catch(err => {
               this.firstLoad = false;
                this.$notify({
                    group: 'response',
                    type: 'error',
                    title:  `${err.response.data.message}`,
                    duration: 5000
                }); 
            })
        })
        .catch(err => {
            this.firstLoad = false;
            this.$notify({
                group: 'response',
                type: 'error',
                title:  `${err.response.data.message}`,
                duration: 5000
            });
        })
    }
}
</script>